import { styled } from 'styled-components';
import { color } from './var';
import { $fontSize, $marginBottom } from './mediaSize';
import { callFromExternal } from '@/utils';

export const TipsWrap = styled.div`
  ${$fontSize('20rem', '12rem')}
  ${$marginBottom('24rem', '20rem')}
  color: ${callFromExternal() ? 'rgba(118, 122, 124, 1)' : color.gray};
  text-align: center;
`;
